import { ref } from "vue";

export function useDirectoryHeader() {
  const headerFontFamily = ref("Lato");
  const headerFontSize = ref("14");
  const headerParagraphFontSize = ref("14");
  const headerTextColor = ref("#121111");
  const headerBoldness = ref("400");
  const headerBackgroundColor = ref("#FFFFFF");
  const headerHeadlineText = ref("Connect with an Expert.");
  const headerParagraphText = ref(
    "Book a quick call and get real, genuine insights from the people that know us best."
  );
  const headerVisible = ref(true);

  const handleHeaderParagraphTextChange = (value: string) => {
    headerParagraphText.value = value;
  };

  const handleHeaderHeadlineTextChange = (value: string) => {
    headerHeadlineText.value = value;
  };

  const handleHeaderFontChange = (value: string) => {
    headerFontFamily.value = value;
  };

  const handleHeaderBoldnessChange = (value: string) => {
    headerBoldness.value = value;
  };

  const handleHeaderTextColorChange = (value: string) => {
    headerTextColor.value = value;
  };

  const handleHeaderBackgroundColorChange = (value: string) => {
    headerBackgroundColor.value = value;
  };

  const handleHeaderFontSizeChange = (value: string) => {
    headerFontSize.value = value;
  };

  const handleHeaderParagraphFontSizeChange = (value: string) => {
    headerParagraphFontSize.value = value;
  };

  const handleHeaderToggleVisibility = (value: boolean) => {
    headerVisible.value = value;
  };

  return {
    headerFontFamily,
    headerFontSize,
    headerParagraphFontSize,
    headerTextColor,
    headerBoldness,
    headerBackgroundColor,
    headerHeadlineText,
    headerParagraphText,
    headerVisible,
    handleHeaderParagraphTextChange,
    handleHeaderHeadlineTextChange,
    handleHeaderFontChange,
    handleHeaderBoldnessChange,
    handleHeaderTextColorChange,
    handleHeaderBackgroundColorChange,
    handleHeaderFontSizeChange,
    handleHeaderParagraphFontSizeChange,
    handleHeaderToggleVisibility,
  };
}
